<template>
  <div class="o-playlist" >
      <div class="o-playlist__position">
        {{ position }}
      </div>

      <div class="o-playlist__image">
        <img v-if="thumbnail" :src="cdnUrl(thumbnail, 'cover/w300')" :alt="title">
      </div>
      <div class="o-playlist__content">
        <HitlistMovement :stats="stats" :position="position" v-if="hasMultipleEditions && stats" />
        <h3 class="o-playlist__title">{{title}}</h3>
        <p class="o-playlist__artist">{{artist}}</p>
      </div>
      <div class="o-playlist__actions">
        <slot></slot>
      </div>
  </div>
</template>

<script>
import {cdnUrl} from '@general/filters/imageFilters'
import HitlistMovement from './HitlistMovement'

export default {
  name: 'Track',
  props: ['position', 'title', 'artist', 'hooks', 'selectorCode', 'thumbnail', 'stats', 'hasMultipleEditions'],
  components: {
    HitlistMovement
  },
  methods: {
    cdnUrl
  }
}
</script>